<template>
  <AppShell>
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </AppShell>
</template>

<script>
import AppShell from '@/components/layout/AppShell.vue';

export default {
  name: 'MainPage',
  components: {
    AppShell
  }
};
</script>
